<template>
  <b-card
    no-body
  >
    <validation-observer ref="validationRef">
      <b-row>
        <b-col md="3">
          <validation-provider
            name="Delay Discount Message En"
            :rules="formRef.delay_discount_enabled ? 'required': ''"
          >
            <b-form-group
              slot-scope="{ errors }"
              label="Delay Discount Message En"
              label-for="Delay Discount Message En"
            >
              <b-form-input
                id="Delay Discount Message En"
                v-model="formRef.delay_discount_message_en"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="3">
          <validation-provider
            name="Delay Discount Message Ar"
            :rules="formRef.delay_discount_enabled ? 'required': ''"
          >
            <b-form-group
              slot-scope="{ errors }"
              label="Delay Discount Message Ar"
              label-for="Delay Discount Message Ar"
            >
              <b-form-input
                id="Delay Discount Message Ar"

                v-model="formRef.delay_discount_message_ar"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </b-form-group>
          </validation-provider>
        </b-col>
        <b-col md="3">
          <b-form-group label="Delay Discount Enabled">
            <BFormCheckbox v-model="formRef.delay_discount_enabled" />
          </b-form-group>
        </b-col>
      </b-row>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BFormGroup, BFormInput, BRow, BCol, BCard, BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from '@validations'
import { ref, watch } from '@vue/composition-api'

export default {
  components: {
    BCard,
    BFormGroup,
    BFormInput,
    BRow,
    BCol,
    ValidationObserver,
    BFormCheckbox,
    ValidationProvider,
  },
  props: {
    delayDiscountMessage: {
      type: Object,
      default: () => ({}),
    },
    delayDiscountEnabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    console.log(props)
    const validationRef = ref(null)

    const formRef = ref({
      delay_discount_message_en: props?.delayDiscountMessage ? props.delayDiscountMessage.en : '',
      delay_discount_message_ar: props?.delayDiscountMessage ? props.delayDiscountMessage.ar : '',
      delay_discount_enabled: props.delayDiscountEnabled !== undefined ? props.delayDiscountEnabled : false,
    })

    watch(formRef, () => {
      emit('input', {
        delay_discount_message: {
          en: formRef.value.delay_discount_message_en,
          ar: formRef.value.delay_discount_message_ar,
        },
        delay_discount_enabled: formRef.value.delay_discount_enabled,
      })
    }, { deep: true })

    return {
      formRef,
      validationRef,
      required,
    }
  },
}
</script>
